
export enum FeatureFlag {
    attendance='attendance',
    notification='notification',
    resources='resources',
}
